/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { ListingDetailParkingSlotResponseDtoParkingType } from './listingDetailParkingSlotResponseDtoParkingType';

export interface ListingDetailParkingSlotResponseDto {
  parkingType: ListingDetailParkingSlotResponseDtoParkingType;
  /** @nullable */
  areaM2: number | null;
  /** @nullable */
  priceAmount: number | null;
  sortOrder: number;
}
